import { render, staticRenderFns } from "./spouse.vue?vue&type=template&id=0db57b0c&"
import script from "./spouse.vue?vue&type=script&lang=js&"
export * from "./spouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports